// <---Actions for Common --->

//snackbar
export const TOASTER = {
  TOASTER_TRIGGER: "trigger",
  TOASTER_SHOW: "show",
};

//loader
export const LOADER = {
  LOADER_TRIGGER: "loader-trigger",
  LOADER_SHOW: "loader-show",
};

//date range picker
export const DATE_RANGEPICKER = {
  DATE_RANGEPICKER_VALUE: "DATE_RANGEPICKER_VALUE",
};

//billing Payload
export const BILLING_PAYLOAD = {
  BILLING_PAYLOAD_VALUE: "BILLING_PAYLOAD_VALUE",
};

//Search Query Parameter
export const SEARCH_QUERY = {
  SEARCH_QUERY_VALUE: "search_query_value",
};

// <-------- API Actions ------>

//Login Action
export const GET_LOGIN = {
  GET_LOGIN_REQUESTED: "GET_LOGIN_REQUESTED",
  GET_LOGIN_SUCCESS: "GET_LOGIN_SUCCESS",
  GET_LOGIN_FAILED: "GET_LOGIN_FAILED",
};

//Otp Action
export const GET_OTP = {
  GET_OTP_REQUESTED: "GET_OTP_REQUESTED",
  GET_OTP_SUCCESS: "GET_OTP_SUCCESS",
  GET_OTP_FAILED: "GET_OTP_FAILED",
};

//Profile
export const GET_PROFILE = {
  GET_PROFILE_REQUESTED: "GET_PROFILE_REQUESTED",
  GET_PROFILE_SUCCESS: "GET_PROFILE_SUCCESS",
  GET_PROFILE_FAILED: "GET_PROFILE_FAILED",
};

export const GET_UPDATEPROFILE = {
  GET_UPDATEPROFILE_REQUESTED: "GET_UPDATEPROFILE_REQUESTED",
  GET_UPDATEPROFILE_SUCCESS: "GET_UPDATEPROFILE_SUCCESS",
  GET_UPDATEPROFILE_FAILED: "GET_UPDATEPROFILE_FAILED",
};

//Roles and permisions
export const GET_ROLESANDPERMISSIONS = {
  GET_ROLESANDPERMISSIONS_REQUESTED: "GET_ROLESANDPERMISSIONS_REQUESTED",
  GET_ROLESANDPERMISSIONS_SUCCESS: "GET_ROLESANDPERMISSIONS_SUCCESS",
  GET_ROLESANDPERMISSIONS_FAILED: "GET_ROLESANDPERMISSIONS_FAILED",
};

//Roles and permisions
export const GET_SUPPLIERROLE = {
  GET_SUPPLIERROLE_REQUESTED: "GET_SUPPLIERROLE_REQUESTED",
  GET_SUPPLIERROLE_SUCCESS: "GET_SUPPLIERROLE_SUCCESS",
  GET_SUPPLIERROLE_FAILED: "GET_SUPPLIERROLE_FAILED",
};

//Company Onboarding

export const GET_COMPANYLIST = {
  GET_COMPANYLIST_REQUESTED: "GET_COMPANYLIST_REQUESTED",
  GET_COMPANYLIST_SUCCESS: "GET_COMPANYLIST_SUCCESS",
  GET_COMPANYLIST_FAILED: "GET_COMPANYLIST_FAILED",
  CLEAR_COMPANYLIST: "CLEAR_COMPANYLIST"
};

export const GET_COMPANY_DETAILS = {
  GET_COMPANY_DETAILS_REQUESTED: "GET_COMPANY_DETAILS_REQUESTED",
  GET_COMPANY_DETAILS_SUCCESS: "GET_COMPANY_DETAILS_SUCCESS",
  GET_COMPANY_DETAILS_FAILED: "GET_COMPANYDETAILS_FAILED",
  CLEAR_COMPANY_DETAILS: "CLEAR_COMPANYDETAILS",
};


export const GET_PARENT_COMPANYLIST = {
  GET_PARENT_COMPANYLIST_REQUESTED: "GET_PARENT_COMPANYLIST_REQUESTED",
  GET_PARENT_COMPANYLIST_SUCCESS: "GET_PARENT_COMPANYLIST_SUCCESS",
  GET_PARENT_COMPANYLIST_FAILED: "GET_PARENT_COMPANYLIST_FAILED",
};

export const GET_ADDCOMPANY = {
  GET_ADDCOMPANY_REQUESTED: "GET_ADDCOMPANY_REQUESTED",
  GET_ADDCOMPANY_SUCCESS: "GET_ADDCOMPANY_SUCCESS",
  GET_ADDCOMPANY_FAILED: "GET_ADDCOMPANY_FAILED",
};

export const GET_UPDATECOMPANY = {
  GET_UPDATECOMPANY_REQUESTED: "GET_UPDATECOMPANY_REQUESTED",
  GET_UPDATECOMPANY_SUCCESS: "GET_UPDATECOMPANY_SUCCESS",
  GET_UPDATECOMPANY_FAILED: "GET_UPDATECOMPANY_FAILED",
};

export const GET_GSTCOMPANY ={
  GET_GSTCOMPANY_REQUESTED: "GET_GSTCOMPANY_REQUESTED",
  GET_GSTCOMPANY_SUCCESS: "GET_GSTCOMPANY_SUCCESS",
  GET_GSTCOMPANY_FAILED: "GET_GSTCOMPANY_FAILED",
}

export const GET_UPDATEGSTCOMPANY ={
  GET_UPDATEGSTCOMPANY_REQUESTED: "GET_UPDATEGSTCOMPANY_REQUESTED",
  GET_UPDATEGSTCOMPANY_SUCCESS: "GET_UPDATEGSTCOMPANY_SUCCESS",
  GET_UPDATEGSTCOMPANY_FAILED: "GET_UPDATEGSTCOMPANY_FAILED",
}

//Company Front desk

export const GET_BOOKINGREPORTS = {
  GET_BOOKINGREPORTS_REQUESTED: "GET_BOOKINGREPORTS_REQUESTED",
  GET_BOOKINGREPORTS_SUCCESS: "GET_BOOKINGREPORTS_SUCCESS",
  GET_BOOKINGREPORTS_FAILED: "GET_BOOKINGREPORTS_FAILED",
};

export const GET_BOOKINGMATRIXREPORTS = {
  GET_BOOKINGMATRIXREPORTS_REQUESTED: "GET_BOOKINGMATRIXREPORTS_REQUESTED",
  GET_BOOKINGMATRIXREPORTS_SUCCESS: "GET_BOOKINGMATRIXREPORTS_SUCCESS",
  GET_BOOKINGMATRIXREPORTS_FAILED: "GET_BOOKINGMATRIXREPORTS_FAILED",
}

export const GET_EMPLOYEESLIST = {
  GET_EMPLOYEESLIST_REQUESTED: "GET_EMPLOYEESLIST_REQUESTED",
  GET_EMPLOYEESLIST_SUCCESS: "GET_EMPLOYEESLIST_SUCCESS",
  GET_EMPLOYEESLIST_CLEARED: "GET_EMPLOYEESLIST_CLEARED",
  GET_EMPLOYEESLIST_FAILED: "GET_EMPLOYEESLIST_FAILED",
};

//Car
export const GET_CAR = {
  GET_CAR_REQUESTED: "GET_CAR_REQUESTED",
  GET_CAR_SUCCESS: "GET_CAR_SUCCESS",
  GET_CAR_FAILED: "GET_CAR_FAILED",
  GET_CAR_CLEAR: "GET_CAR_CLEAR",
};

//Add Rate Card Action
export const GET_ADDRATECARD = {
  GET_ADDRATECARD_REQUESTED: "GET_ADDRATECARD_REQUESTED",
  GET_ADDRATECARD_SUCCESS: "GET_ADDRATECARD_SUCCESS",
  GET_ADDRATECARD_FAILED: "GET_ADDRATECARD_FAILED",
};

// Add Service City Action
export const GET_SERVICECITY = {
  GET_SERVICECITY_REQUESTED: "GET_SERVICECITY_REQUESTED",
  GET_SERVICECITY_SUCCESS: "GET_SERVICECITY_SUCCESS",
  GET_SERVICECITY_FAILED: "GET_SERVICECITY_FAILED",
};

export const GET_SERVICEREGION = {
  GET_SERVICEREGION_REQUESTED: "GET_SERVICEREGION_REQUESTED",
  GET_SERVICEREGION_SUCCESS: "GET_SERVICEREGION_SUCCESS",
  GET_SERVICEREGION_FAILED: "GET_SERVICEREGION_FAILED",
};

export const GET_SUBVENDORREGION = {
  GET_SUBVENDORREGION_REQUESTED: "GET_SUBVENDORREGION_REQUESTED",
  GET_SUBVENDORREGION_SUCCESS: "GET_SUBVENDORREGION_SUCCESS",
  GET_SUBVENDORREGION_FAILED: "GET_SUBVENDORREGION_FAILED",
};



//Get Rate Card Action
export const GET_RATECARD = {
  GET_RATECARD_REQUESTED: "GET_RATECARD_REQUESTED",
  GET_RATECARD_SUCCESS: "GET_RATECARD_SUCCESS",
  GET_RATECARD_FAILED: "GET_RATECARD_FAILED",
  GET_RATECARD_CLEAR: "GET_RATECARD_CLEAR",
};

//SUb vendor
export const GET_SUBVENDOR_LIST = {
  GET_SUBVENDOR_LIST_REQUESTED: "GET_SUBVENDOR_LIST_REQUESTED",
  GET_SUBVENDOR_LIST_SUCCESS: "GET_SUBVENDOR_LIST_SUCCESS",
  GET_SUBVENDOR_LIST_FAILED: "GET_SUBVENDOR_LIST_FAILED",
};

export const GET_SUBVENDOR_DETAILS = {
  GET_SUBVENDOR_DETAILS_REQUESTED: "GET_SUBVENDOR_DETAILS_REQUESTED",
  GET_SUBVENDOR_DETAILS_SUCCESS: "GET_SUBVENDOR_DETAILS_SUCCESS",
  GET_SUBVENDOR_DETAILS_FAILED: "GET_SUBVENDOR_DETAILS_FAILED",
};

export const GET_ADDSUBVENDOR = {
  GET_ADDSUBVENDOR_REQUESTED: "GET_ADDSUBVENDOR_REQUESTED",
  GET_ADDSUBVENDOR_SUCCESS: "GET_ADDSUBVENDOR_SUCCESS",
  GET_ADDSUBVENDOR_FAILED: "GET_ADDSUBVENDOR_FAILED",
};

export const GET_UPDATESUBVENDOR = {
  GET_UPDATESUBVENDOR_REQUESTED: "GET_UPDATESUBVENDOR_REQUESTED",
  GET_UPDATESUBVENDOR_SUCCESS: "GET_UPDATESUBVENDOR_SUCCESS",
  GET_UPDATESUBVENDOR_FAILED: "GET_UPDATESUBVENDOR_FAILED",
};

//Actions for Vehicle
export const GET_VEHICLE = {
  GET_VEHICLE_REQUESTED: "GET_VEHICLE_REQUESTED",
  GET_VEHICLE_SUCCESS: "GET_VEHICLE_SUCCESS",
  GET_VEHICLE_FAILED: "GET_VEHICLE_FAILED",
};

export const GET_MOREVEHICLE = {
  GET_MOREVEHICLE_REQUESTED: "GET_MOREVEHICLE_REQUESTED",
  GET_MOREVEHICLE_SUCCESS: "GET_MOREVEHICLE_SUCCESS",
  GET_MOREVEHICLE_FAILED: "GET_MOREVEHICLE_FAILED",
};

export const GET_ADDVEHICLE = {
  GET_ADDVEHICLE_REQUESTED: "GET_ADDVEHICLE_REQUESTED",
  GET_ADDVEHICLE_SUCCESS: "GET_ADDVEHICLE_SUCCESS",
  GET_ADDVEHICLE_FAILED: "GET_ADDVEHICLE_FAILED",
};

export const GET_DELETEVEHICLE = {
  GET_DELETEVEHICLE_REQUESTED: "GET_DELETEVEHICLE_REQUESTED",
  GET_DELETEVEHICLE_SUCCESS: "GET_DELETEVEHICLE_SUCCESS",
  GET_DELETEVEHICLE_FAILED: "GET_DELETEVEHICLE_FAILED",
};

export const GET_UPDATEVEHICLE = {
  GET_UPDATEVEHICLE_REQUESTED: "GET_UPDATEVEHICLE_REQUESTED",
  GET_UPDATEVEHICLE_SUCCESS: "GET_UPDATEVEHICLE_SUCCESS",
  GET_UPDATEVEHICLE_FAILED: "GET_UPDATEVEHICLE_FAILED",
};

export const GET_MATRIXVEHICLE = {
  GET_MATRIXVEHICLE_REQUESTED: "GET_MATRIXVEHICLE_REQUESTED",
  GET_MATRIXVEHICLE_SUCCESS: "GET_MATRIXVEHICLE_SUCCESS",
  GET_MATRIXVEHICLE_FAILED: "GET_MATRIXVEHICLE_FAILED",
};

//Driver 
export const GET_DRIVER_LIST = {
  GET_DRIVER_LIST_REQUESTED: "GET_DRIVER_LIST_REQUESTED",
  GET_DRIVER_LIST_SUCCESS: "GET_DRIVER_LIST_SUCCESS",
  GET_DRIVER_LIST_FAILED: "GET_DRIVER_LIST_FAILED",
};

export const GET_ADDDRIVER = {
  GET_ADDDRIVER_REQUESTED: "GET_ADDDRIVER_REQUESTED",
  GET_ADDDRIVER_SUCCESS: "GET_ADDDRIVER_SUCCESS",
  GET_ADDDRIVER_FAILED: "GET_ADDDRIVER_FAILED",
};

export const GET_UPDATEDRIVER = {
  GET_UPDATEDRIVER_REQUESTED: "GET_UPDATEDRIVER_REQUESTED",
  GET_UPDATEDRIVER_SUCCESS: "GET_UPDATEDRIVER_SUCCESS",
  GET_UPDATEDRIVER_FAILED: "GET_UPDATEDRIVER_FAILED",
};

export const GET_MATRIXDRIVER = {
  GET_MATRIXDRIVER_REQUESTED: "GET_MATRIXDRIVER_REQUESTED",
  GET_MATRIXDRIVER_SUCCESS: "GET_MATRIXDRIVER_SUCCESS",
  GET_MATRIXDRIVER_FAILED: "GET_MATRIXDRIVER_FAILED",
};

export const GET_TICKETDRIVER = {
  GET_TICKETDRIVER_REQUESTED: "GET_TICKETDRIVER_REQUESTED",
  GET_TICKETDRIVER_SUCCESS: "GET_TICKETDRIVER_SUCCESS",
  GET_TICKETDRIVER_FAILED: "GET_TICKETDRIVER_FAILED",
};

export const GET_MOREDRIVER = {
  GET_MOREDRIVER_REQUESTED: "GET_MOREDRIVER_REQUESTED",
  GET_MOREDRIVER_SUCCESS: "GET_MOREDRIVER_SUCCESS",
  GET_MOREDRIVER_FAILED: "GET_MOREDRIVER_FAILED",
};

//Compliance Actions
// export const GET_COMPLIANCE = {
//   GET_COMPLIANCE_REQUESTED: "GET_COMPLIANCE_REQUESTED",
//   GET_COMPLIANCE_SUCCESS: "GET_COMPLIANCE_SUCCESS",
//   GET_COMPLIANCE_FAILED: "GET_COMPLIANCE_FAILED",
// };

// export const GET_ONBOARD_COMPLIANCE = {
//   GET_ONBOARD_COMPLIANCE_REQUESTED: "GET_ONBOARD_COMPLIANCE_REQUESTED",
//   GET_ONBOARD_COMPLIANCE_SUCCESS: "GET_ONBOARD_COMPLIANCE_SUCCESS",
//   GET_ONBOARD_COMPLIANCE_FAILED: "GET_ONBOARD_COMPLIANCE_FAILED",
// };

//Dashboard
export const GET_OURCAR = {
  GET_OURCAR_REQUESTED: "GET_OURCAR_REQUESTED",
  GET_OURCAR_SUCCESS: "GET_OURCAR_SUCCESS",
  GET_OURCAR_FAILED: "GET_OURCAR_FAILED",
};

export const GET_RIDE_DETAILS = {
  GET_RIDE_DETAILS_REQUESTED: "GET_RIDE_DETAILS_REQUESTED",
  GET_RIDE_DETAILS_SUCCESS: "GET_RIDE_DETAILS_SUCCESS",
  GET_RIDE_DETAILS_FAILED: "GET_RIDE_DETAILS_FAILED",
};

export const GET_RIDE_ANALYTICS = {
  GET_RIDE_ANALYTICS_REQUESTED: "GET_RIDE_ANALYTICS_REQUESTED",
  GET_RIDE_ANALYTICS_SUCCESS: "GET_RIDE_ANALYTICS_SUCCESS",
  GET_RIDE_ANALYTICS_FAILED: "GET_RIDE_ANALYTICS_FAILED",
};

export const GET_TOTAL_REGISTRATION = {
  GET_TOTAL_REGISTRATION_REQUESTED: "GET_TOTAL_REGISTRATION_REQUESTED",
  GET_TOTAL_REGISTRATION_SUCCESS: "GET_TOTAL_REGISTRATION_SUCCESS",
  GET_TOTAL_REGISTRATION_FAILED: "GET_TOTAL_REGISTRATION_FAILED",
};


//USER DUTY TYPE
export const GET_DUTYTYPE = {
  GET_DUTYTYPE_REQUESTED: "GET_DUTYTYPE_REQUESTED",
  GET_DUTYTYPE_SUCCESS: "GET_DUTYTYPE_SUCCESS",
  GET_DUTYTYPE_FAILED: "GET_DUTYTYPE_FAILED",
};

//Choose Your Service Action
export const GET_CHOOSEYOURSERVICE = "GET_CHOOSEYOURSERVICE";
export const GET_CHOOSEYOURSERVICE_REQUESTED = "GET_CHOOSEYOURSERVICE_REQUESTED";
export const GET_CHOOSEYOURSERVICE_SUCCESS = "GET_CHOOSEYOURSERVICE_SUCCESS";
export const GET_CHOOSEYOURSERVICE_FAILED = "GET_CHOOSEYOURSERVICE_FAILED";

//Create Choose Your Service Action
export const GET_ADDCHOOSEYOURSERVICE = "GET_ADDCHOOSEYOURSERVICE";
export const GET_ADDCHOOSEYOURSERVICE_REQUESTED = "GET_ADDCHOOSEYOURSERVICE_REQUESTED";
export const GET_ADDCHOOSEYOURSERVICE_SUCCESS = "GET_ADDCHOOSEYOURSERVICE_SUCCESS";
export const GET_ADDCHOOSEYOURSERVICE_FAILED = "GET_ADDCHOOSEYOURSERVICE_FAILED";

//Update Choose Your Service Action
export const GET_UPDATECHOOSEYOURSERVICE = "GET_UPDATECHOOSEYOURSERVICE";
export const GET_UPDATECHOOSEYOURSERVICE_REQUESTED = "GET_UPDATECHOOSEYOURSERVICE_REQUESTED";
export const GET_UPDATECHOOSEYOURSERVICE_SUCCESS = "GET_UPDATECHOOSEYOURSERVICE_SUCCESS";
export const GET_UPDATECHOOSEYOURSERVICE_FAILED = "GET_UPDATECHOOSEYOURSERVICE_FAILED";

//Reservation
export const GET_RESERVATIONLIST = {
  GET_RESERVATIONLIST_REQUESTED: "GET_RESERVATIONLIST_REQUESTED",
  GET_RESERVATIONLIST_SUCCESS: "GET_RESERVATIONLIST_SUCCESS",
  GET_RESERVATIONLIST_FAILED: "GET_RESERVATIONLIST_FAILED",
};

export const GET_RESERVATIONDETAILS = {
  GET_RESERVATIONDETAILS_REQUESTED: "GET_RESERVATIONDETAILS_REQUESTED",
  GET_RESERVATIONDETAILS_SUCCESS: "GET_RESERVATIONDETAILS_SUCCESS",
  GET_RESERVATIONDETAILS_FAILED: "GET_RESERVATIONDETAILS_FAILED",
  CLEAR_RESERVATIONDETAILS: "CLEAR_RESERVATIONDETAILS"
};

export const GET_AIRPORTTERMINALLIST = {
  GET_AIRPORTTERMINALLIST_REQUESTED: "GET_AIRPORTTERMINALLIST_REQUESTED",
  GET_AIRPORTTERMINALLIST_SUCCESS: "GET_AIRPORTTERMINALLIST_SUCCESS",
  GET_AIRPORTTERMINALLIST_FAILED: "GET_AIRPORTTERMINALLIST_FAILED",
};

export const GET_ADDRESERVATION = {
  GET_ADDRESERVATION_REQUESTED: "GET_ADDRESERVATION_REQUESTED",
  GET_ADDRESERVATION_SUCCESS: "GET_ADDRESERVATION_SUCCESS",
  GET_ADDRESERVATION_FAILED: "GET_ADDRESERVATION_FAILED",
};

export const GET_BOOKINGBUFFERTIME = {
  GET_BOOKINGBUFFERTIME_REQUESTED: "GET_BOOKINGBUFFERTIME_REQUESTED",
  GET_BOOKINGBUFFERTIME_SUCCESS: "GET_BOOKINGBUFFERTIME_SUCCESS",
  GET_BOOKINGBUFFERTIME_FAILED: "GET_BOOKINGBUFFERTIME_FAILED",
};

export const GET_UPDATERESERVATION = {
  GET_UPDATERESERVATION_REQUESTED: "GET_UPDATERESERVATION_REQUESTED",
  GET_UPDATERESERVATION_SUCCESS: "GET_UPDATERESERVATION_SUCCESS",
  GET_UPDATERESERVATION_FAILED: "GET_UPDATERESERVATION_FAILED",
};

export const GET_CANCELREASON = {
  GET_CANCELREASON_REQUESTED: "GET_CANCELREASON_REQUESTED",
  GET_CANCELREASON_SUCCESS: "GET_CANCELREASON_SUCCESS",
  GET_CANCELREASON_FAILED: "GET_CANCELREASON_FAILED",
};

//Operation
export const GET_ALLOTVEHICLE = {
  GET_ALLOTVEHICLE_REQUESTED: "GET_ALLOTVEHICLE_REQUESTED",
  GET_ALLOTVEHICLE_SUCCESS: "GET_ALLOTVEHICLE_SUCCESS",
  GET_ALLOTVEHICLE_FAILED: "GET_ALLOTVEHICLE_FAILED",
};

export const GET_AVAILABLEVEHICLE = {
  GET_AVAILABLEVEHICLE_REQUESTED: "GET_AVAILABLEVEHICLE_REQUESTED",
  GET_AVAILABLEVEHICLE_SUCCESS: "GET_AVAILABLEVEHICLE_SUCCESS",
  GET_AVAILABLEVEHICLE_FAILED: "GET_AVAILABLEVEHICLE_FAILED",
  GET_AVAILABLEVEHICLE_CLEAR: "GET_AVAILABLEVEHICLE_CLEAR",

};

export const GET_AVAILABLESUPPLIERS = {
  GET_AVAILABLESUPPLIERS_REQUESTED: "GET_AVAILABLESUPPLIERS_REQUESTED",
  GET_AVAILABLESUPPLIERS_SUCCESS: "GET_AVAILABLESUPPLIERS_SUCCESS",
  GET_AVAILABLESUPPLIERS_FAILED: "GET_AVAILABLESUPPLIERS_FAILED",
  GET_AVAILABLESUPPLIERS_CLEAR: "GET_AVAILABLESUPPLIERS_CLEAR",
};


export const GET_DISPATCHVEHICLE = {
  GET_DISPATCHVEHICLE_REQUESTED: "GET_DISPATCHVEHICLE_REQUESTED",
  GET_DISPATCHVEHICLE_SUCCESS: "GET_DISPATCHVEHICLE_SUCCESS",
  GET_DISPATCHVEHICLE_FAILED: "GET_DISPATCHVEHICLE_FAILED",
};

export const GET_CANCELTRIP = {
  GET_CANCELTRIP_REQUESTED: "GET_CANCELTRIP_REQUESTED",
  GET_CANCELTRIP_SUCCESS: "GET_CANCELTRIP_SUCCESS",
  GET_CANCELTRIP_FAILED: "GET_CANCELTRIP_FAILED",
};

export const GET_CANCELCHARGES = {
  GET_CANCELCHARGES_REQUESTED: "GET_CANCELCHARGES_REQUESTED",
  GET_CANCELCHARGES_SUCCESS: "GET_CANCELCHARGES_SUCCESS",
  GET_CANCELCHARGES_FAILED: "GET_CANCELCHARGES_FAILED",
};

export const GET_BILLINGLIST = {
  GET_BILLINGLIST_REQUESTED: "GET_BILLINGLIST_REQUESTED",
  GET_BILLINGLIST_SUCCESS: "GET_BILLINGLIST_SUCCESS",
  GET_BILLINGLIST_FAILED: "GET_BILLINGLIST_FAILED",
  GET_BILLINGLIST_CLEARED: "GET_BILLINGLIST_CLEARED",
}

export const GET_BILLINGINVOICEDETAILS = {
  GET_BILLINGINVOICEDETAILS_REQUESTED: "GET_BILLINGINVOICEDETAILS_REQUESTED",
  GET_BILLINGINVOICEDETAILS_SUCCESS: "GET_BILLINGINVOICEDETAILS_SUCCESS",
  GET_BILLINGINVOICEDETAILS_FAILED: "GET_BILLINGINVOICEDETAILS_FAILED",
}

export const GET_BILLINGPRICEDETAILS = {
  GET_BILLINGPRICEDETAILS_REQUESTED: "GET_BILLINGPRICEDETAILS_REQUESTED",
  GET_BILLINGPRICEDETAILS_SUCCESS: "GET_BILLINGPRICEDETAILS_SUCCESS",
  GET_BILLINGPRICEDETAILS_FAILED: "GET_BILLINGPRICEDETAILS_FAILED",
}

export const ADD_BILLINGPRICEDETAILS = {
  ADD_BILLINGPRICEDETAILS_REQUESTED: "ADD_BILLINGPRICEDETAILS_REQUESTED",
  ADD_BILLINGPRICEDETAILS_SUCCESS: "ADD_BILLINGPRICEDETAILS_SUCCESS",
  ADD_BILLINGPRICEDETAILS_FAILED: "ADD_BILLINGPRICEDETAILS_FAILED",
}

export const ADD_BILLINGREQUESTAPPROVAL = {
  ADD_BILLINGREQUESTAPPROVAL_REQUESTED: "ADD_BILLINGREQUESTAPPROVAL_REQUESTED",
  ADD_BILLINGREQUESTAPPROVAL_SUCCESS: "ADD_BILLINGREQUESTAPPROVAL_SUCCESS",
  ADD_BILLINGREQUESTAPPROVAL_FAILED: "ADD_BILLINGREQUESTAPPROVAL_FAILED",
}

export const ADD_BILLINGCONSOLIDATEDINVOICE = {
  ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED: "ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED",
  ADD_BILLINGCONSOLIDATEDINVOICE_SUCCESS: "ADD_BILLINGCONSOLIDATEDINVOICE_SUCCESS",
  ADD_BILLINGCONSOLIDATEDINVOICE_FAILED: "ADD_BILLINGCONSOLIDATEDINVOICE_FAILED",
}

export const GET_BILLINGCONSOLIDATEDINVOICE = {
  GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED: "GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED",
  GET_BILLINGCONSOLIDATEDINVOICE_SUCCESS: "GET_BILLINGCONSOLIDATEDINVOICE_SUCCESS",
  GET_BILLINGCONSOLIDATEDINVOICE_FAILED: "GET_BILLINGCONSOLIDATEDINVOICE_FAILED",
}

export const GET_BILLINGEXTRACHARGECALCULATION = {
  GET_BILLINGEXTRACHARGECALCULATION_REQUESTED: "GET_BILLINGEXTRACHARGECALCULATION_REQUESTED",
  GET_BILLINGEXTRACHARGECALCULATION_SUCCESS: "GET_BILLINGEXTRACHARGECALCULATION_SUCCESS",
  GET_BILLINGEXTRACHARGECALCULATION_FAILED: "GET_BILLINGEXTRACHARGECALCULATION_FAILED",
}

export const ADD_BILLINGGENERATEINVOICE  = {
  ADD_BILLINGGENERATEINVOICE_REQUESTED: "ADD_BILLINGGENERATEINVOICE _REQUESTED",
  ADD_BILLINGGENERATEINVOICE_SUCCESS: "ADD_BILLINGGENERATEINVOICE_SUCCESS",
  ADD_BILLINGGENERATEINVOICE_FAILED: "ADD_BILLINGGENERATEINVOICE_FAILED",
}

//Vendor Action
export const GET_VENDOR = "GET_VENDOR";
export const GET_VENDOR_REQUESTED = "GET_VENDOR_REQUESTED";
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const GET_VENDOR_FAILED = "GET_VENDOR_FAILED";

//Create Vendor Action
export const GET_ADDVENDOR = "GET_ADDVENDOR";
export const GET_ADDVENDOR_REQUESTED = "GET_ADDVENDOR_REQUESTED";
export const GET_ADDVENDOR_SUCCESS = "GET_ADDVENDOR_SUCCESS";
export const GET_ADDVENDOR_FAILED = "GET_ADDVENDOR_FAILED";

//Update Vendor Action
export const GET_UPDATEVENDOR = "GET_UPDATEVENDOR";
export const GET_UPDATEVENDOR_REQUESTED = "GET_UPDATEVENDOR_REQUESTED";
export const GET_UPDATEVENDOR_SUCCESS = "GET_UPDATEVENDOR_SUCCESS";
export const GET_UPDATEVENDOR_FAILED = "GET_UPDATEVENDOR_FAILED";

//Get Vendor user Action
export const GET_VENDORUSER = "GET_VENDORUSER";
export const GET_VENDORUSER_REQUESTED = "GET_VENDORUSER_REQUESTED";
export const GET_VENDORUSER_SUCCESS = "GET_VENDORUSER_SUCCESS";
export const GET_VENDORUSER_FAILED = "GET_VENDORUSER_FAILED";

//Compliance Action
export const GET_COMPLIANCE = "GET_COMPLIANCE";
export const GET_COMPLIANCE_REQUESTED = "GET_COMPLIANCE_REQUESTED";
export const GET_COMPLIANCE_SUCCESS = "GET_COMPLIANCE_SUCCESS";
export const GET_COMPLIANCE_FAILED = "GET_COMPLIANCE_FAILED";

//Config Compliance Action
export const GET_CONFIGCOMPLIANCE = "GET_CONFIGCOMPLIANCE";
export const GET_CONFIGCOMPLIANCE_REQUESTED = "GET_CONFIGCOMPLIANCE_REQUESTED";
export const GET_CONFIGCOMPLIANCE_SUCCESS = "GET_CONFIGCOMPLIANCE_SUCCESS";
export const GET_CONFIGCOMPLIANCE_FAILED = "GET_CONFIGCOMPLIANCE_FAILED";

//Approve Reject Compliance Action
export const GET_APPROVECOMPLIANCE = "GET_APPROVECOMPLIANCE";
export const GET_APPROVECOMPLIANCE_REQUESTED = "GET_APPROVECOMPLIANCE_REQUESTED";
export const GET_APPROVECOMPLIANCE_SUCCESS = "GET_APPROVECOMPLIANCE_SUCCESS";
export const GET_APPROVECOMPLIANCE_FAILED = "GET_APPROVECOMPLIANCE_FAILED";

//Create Config Compliance Action
export const GET_ADDCOMPLIANCE = "GET_ADDCOMPLIANCE";
export const GET_ADDCOMPLIANCE_REQUESTED = "GET_ADDCOMPLIANCE_REQUESTED";
export const GET_ADDCOMPLIANCE_SUCCESS = "GET_ADDCOMPLIANCE_SUCCESS";
export const GET_ADDCOMPLIANCE_FAILED = "GET_ADDCOMPLIANCE_FAILED";

//Update Config Compliance Action
export const GET_UPDATECOMPLIANCE = "GET_UPDATECOMPLIANCE";
export const GET_UPDATECOMPLIANCE_REQUESTED = "GET_UPDATECOMPLIANCE_REQUESTED";
export const GET_UPDATECOMPLIANCE_SUCCESS = "GET_UPDATECOMPLIANCE_SUCCESS";
export const GET_UPDATECOMPLIANCE_FAILED = "GET_UPDATECOMPLIANCE_FAILED";

//Onboard-Compliance Action
export const GET_ONBOARD_COMPLIANCE = "GET_ONBOARD_COMPLIANCE";
export const GET_ONBOARD_COMPLIANCE_REQUESTED = "GET_ONBOARD_COMPLIANCE_REQUESTED";
export const GET_ONBOARD_COMPLIANCE_SUCCESS = "GET_ONBOARD_COMPLIANCE_SUCCESS";
export const GET_ONBOARD_COMPLIANCE_FAILED = "GET_ONBOARD_COMPLIANCE_FAILED";

//Create Onboard-Compliance Action
export const GET_ADDONBOARD_COMPLIANCE = "GET_ADDONBOARD_COMPLIANCE";
export const GET_ADDONBOARD_COMPLIANCE_REQUESTED = "GET_ADDONBOARD_COMPLIANCE_REQUESTED";
export const GET_ADDONBOARD_COMPLIANCE_SUCCESS = "GET_ADDONBOARD_COMPLIANCE_SUCCESS";
export const GET_ADDONBOARD_COMPLIANCE_FAILED = "GET_ADDONBOARD_COMPLIANCE_FAILED";


//Google Map AutoComplete
export const GET_GOOGLEAUTOSUGGESTIONS = {
  GET_GOOGLEAUTOSUGGESTIONS_REQUESTED: "GET_GOOGLEAUTOSUGGESTIONS_REQUESTED",
  GET_GOOGLEAUTOSUGGESTIONS_SUCCESS:  "GET_GOOGLEAUTOSUGGESTIONS_SUCCESS",
  GET_GOOGLEAUTOSUGGESTIONS_FAILED:  "GET_GOOGLEAUTOSUGGESTIONS_FAILED",
  GET_GOOGLEAUTOSUGGESTIONS_CLEARED:  "GET_GOOGLEAUTOSUGGESTIONS_CLEARED"
}


//Google Map Place details
export const GET_GOOGLEMAPPLACEDETAILS = {
  GET_GOOGLEMAPPLACEDETAILS_REQUESTED: "GET_GOOGLEMAPPLACEDETAILS_REQUESTED",
  GET_GOOGLEMAPPLACEDETAILS_SUCCESS:  "GET_GOOGLEMAPPLACEDETAILS_SUCCESS",
  GET_GOOGLEMAPPLACEDETAILS_FAILED:  "GET_GOOGLEMAPPLACEDETAILS_FAILED",
  GET_GOOGLEMAPPLACEDETAILS_CLEARED:  "GET_GOOGLEMAPPLACEDETAILS_CLEARED",
  GET_GOOGLEMAPPLACEDETAILSPICKUP_SUCCESS:  "GET_GOOGLEMAPPLACEDETAILSPICKUP_SUCCESS",
  GET_GOOGLEMAPPLACEDETAILSDROP_SUCCESS:  "GET_GOOGLEMAPPLACEDETAILSDROP_SUCCESS",
  GET_GOOGLEMAPPLACEDETAILSLANDMARK_SUCCESS:  "GET_GOOGLEMAPPLACEDETAILSLANDMARK_SUCCESS",
}

//Google Map Direction details
export const GET_GOOGLEMAPDIRECTION = {
  GET_GOOGLEMAPDIRECTION_REQUESTED: "GET_GOOGLEMAPDIRECTION_REQUESTED",
  GET_GOOGLEMAPDIRECTION_SUCCESS:  "GET_GOOGLEMAPDIRECTION_SUCCESS",
  GET_GOOGLEMAPDIRECTION_FAILED:  "GET_GOOGLEMAPDIRECTION_FAILED",
  GET_GOOGLEMAPDIRECTION_CLEARED:  "GET_GOOGLEMAPDIRECTION_CLEARED",
}

//Google Map Geocode details
export const GET_GEOCODE = {
  GET_GEOCODE_REQUESTED: "GET_GEOCODE_REQUESTED",
  GET_GEOCODE_SUCCESS:  "GET_GEOCODE_SUCCESS",
  GET_GEOCODE_FAILED:  "GET_GEOCODE_FAILED",
}

//Settlememnt GET

export const GET_SETTLEMENTLIST = {
  GET_SETTLEMENTLIST_REQUESTED: "GET_SETTLEMENTLIST_REQUESTED",
  GET_SETTLEMENTLIST_SUCCESS: "GET_SETTLEMENTLIST_SUCCESS",
  GET_SETTLEMENTLIST_FAILED: "GET_SETTLEMENTLIST_FAILED",
};

export const GET_SETTLEMENTDETAILS = {
  GET_SETTLEMENTDETAILS_REQUESTED: "GET_SETTLEMENTDETAILS_REQUESTED",
  GET_SETTLEMENTDETAILS_SUCCESS: "GET_SETTLEMENTDETAILS_SUCCESS",
  GET_SETTLEMENTDETAILS_FAILED: "GET_SETTLEMENTDETAILS_FAILED",
};

export const GET_ADDSETTLEMENT = {
  GET_ADDSETTLEMENT_REQUESTED: "GET_ADDSETTLEMENT_REQUESTED",
  GET_ADDSETTLEMENT_SUCCESS: "GET_ADDSETTLEMENT_SUCCESS",
  GET_ADDSETTLEMENT_FAILED: "GET_ADDSETTLEMENT_FAILED",
};

export const GET_UPDATESETTLEMENT = {
  GET_UPDATESETTLEMENT_REQUESTED: "GET_UPDATESETTLEMENT_REQUESTED",
  GET_UPDATESETTLEMENT_SUCCESS: "GET_UPDATESETTLEMENT_SUCCESS",
  GET_UPDATESETTLEMENT_FAILED: "GET_UPDATESETTLEMENT_FAILED",
};

// Request Assign Vehicle Action
export const GET_REQUESTVEHICLE = "GET_REQUESTVEHICLE";
export const GET_REQUESTVEHICLE_REQUESTED = "GET_REQUESTVEHICLE_REQUESTED";
export const GET_REQUESTVEHICLE_SUCCESS = "GET_REQUESTVEHICLE_SUCCESS";
export const GET_REQUESTVEHICLE_FAILED = "GET_REQUESTVEHICLE_FAILED";

// Assigned Vehicle Action
export const GET_LISTASSIGNEDVEHICLE = "GET_LISTASSIGNEDVEHICLE";
export const GET_LISTASSIGNEDVEHICLE_REQUESTED = "GET_LISTASSIGNEDVEHICLE_REQUESTED";
export const GET_LISTASSIGNEDVEHICLE_SUCCESS = "GET_LISTASSIGNEDVEHICLE_SUCCESS";
export const GET_LISTASSIGNEDVEHICLE_FAILED = "GET_LISTASSIGNEDVEHICLE_FAILED";

// List of Drivers Vehicle Action
export const GET_ASSIGNVEHICLE = "GET_ASSIGNVEHICLE";
export const GET_ASSIGNVEHICLE_REQUESTED = "GET_ASSIGNVEHICLE_REQUESTED";
export const GET_ASSIGNVEHICLE_SUCCESS = "GET_ASSIGNVEHICLE_SUCCESS";
export const GET_ASSIGNVEHICLE_FAILED = "GET_ASSIGNVEHICLE_FAILED";

// Update Assign Vehicle Action
export const GET_UPDATEASSIGNVEHICLE = "GET_UPDATEASSIGNVEHICLE";
export const GET_UPDATEASSIGNVEHICLE_REQUESTED = "GET_UPDATEASSIGNVEHICLE_REQUESTED";
export const GET_UPDATEASSIGNVEHICLE_SUCCESS = "GET_UPDATEASSIGNVEHICLE_SUCCESS";
export const GET_UPDATEASSIGNVEHICLE_FAILED = "GET_UPDATEASSIGNVEHICLE_FAILED";

//Update Assign Driver Action
export const GET_UPDATEASSIGNDRIVER = "GET_UPDATEASSIGNDRIVER";
export const GET_UPDATEASSIGNDRIVER_REQUESTED = "GET_UPDATEASSIGNDRIVER_REQUESTED";
export const GET_UPDATEASSIGNDRIVER_SUCCESS = "GET_UPDATEASSIGNDRIVER_SUCCESS";
export const GET_UPDATEASSIGNDRIVER_FAILED = "GET_UPDATEASSIGNDRIVER_FAILED";

//Get Assign Driver Action
export const GET_ASSIGN_DRIVER = "GET_ASSIGN_DRIVER";
export const GET_ASSIGN_DRIVER_REQUESTED = "GET_ASSIGN_DRIVER_REQUESTED";
export const GET_ASSIGN_DRIVER_SUCCESS = "GET_ASSIGN_DRIVER_SUCCESS";
export const GET_ASSIGN_DRIVER_FAILED = "GET_ASSIGN_DRIVER_FAILED";

//Update Assign SubVendor Action
export const GET_UPDATEASSIGNSUBVENDOR = "GET_UPDATEASSIGNSUBVENDOR";
export const GET_UPDATEASSIGNSUBVENDOR_REQUESTED = "GET_UPDATEASSIGNSUBVENDOR_REQUESTED";
export const GET_UPDATEASSIGNSUBVENDOR_SUCCESS = "GET_UPDATEASSIGNSUBVENDOR_SUCCESS";
export const GET_UPDATEASSIGNSUBVENDOR_FAILED = "GET_UPDATEASSIGNSUBVENDOR_FAILED";

//corporate Customer Report
export const GET_CUSTOMERSREPORTS = {
  GET_CUSTOMERSREPORTS_REQUESTED: "GET_CUSTOMERSREPORTS_REQUESTED",
  GET_CUSTOMERSREPORTS_SUCCESS: "GET_CUSTOMERSREPORTS_SUCCESS",
  GET_CUSTOMERSREPORTS_FAILED: "GET_CUSTOMERSREPORTS_FAILED",
};

//corporate Customer Report Matrix
export const GET_CUSTOMERMATRIXREPORTS = {
  GET_CUSTOMERMATRIXREPORTS_REQUESTED: "GET_CUSTOMERMATRIXREPORTS_REQUESTED",
  GET_CUSTOMERMATRIXREPORTS_SUCCESS: "GET_CUSTOMERMATRIXREPORTS_SUCCESS",
  GET_CUSTOMERMATRIXREPORTS_FAILED: "GET_CUSTOMERMATRIXREPORTS_FAILED",
}

//Revenue Report
export const GET_REVENUEREPORTS = {
  GET_REVENUEREPORTS_REQUESTED: "GET_REVENUEREPORTS_REQUESTED",
  GET_REVENUEREPORTS_SUCCESS: "GET_REVENUEREPORTS_SUCCESS",
  GET_REVENUEREPORTS_FAILED: "GET_REVENUEREPORTS_FAILED",
};

//Mis Report
export const GET_MISREPORTS = {
  GET_MISREPORTS_REQUESTED: "GET_MISREPORTS_REQUESTED",
  GET_MISREPORTS_SUCCESS: "GET_MISREPORTS_SUCCESS",
  GET_MISREPORTS_FAILED: "GET_MISREPORTS_FAILED",
};

//revenue Report Matrix
export const GET_REVENUEMATRIXREPORTS = {
   GET_REVENUEMATRIXREPORTS_REQUESTED: " GET_REVENUEMATRIXREPORTS_REQUESTED",
   GET_REVENUEMATRIXREPORTS_SUCCESS: " GET_REVENUEMATRIXREPORTS_SUCCESS",
   GET_REVENUEMATRIXREPORTS_FAILED: " GET_REVENUEMATRIXREPORTS_FAILED",
}
// Create Magic Token
export const GET_ADDMAGICTOKEN = {
  GET_ADDMAGICTOKEN_REQUESTED: "GET_ADDMAGICTOKEN_REQUESTED",
  GET_ADDMAGICTOKEN_SUCCESS: "GET_ADDMAGICTOKEN_SUCCESS",
  GET_ADDMAGICTOKEN_FAILED: "GET_ADDMAGICTOKEN_FAILED",
};

// Verify Magic Token
export const GET_VERIFYMAGICTOKEN = {
 GET_VERIFYMAGICTOKEN_REQUESTED: 'GET_VERIFYMAGICTOKEN_REQUESTED',
 GET_VERIFYMAGICTOKEN_SUCCESS :'GET_VERIFYMAGICTOKEN_SUCCESS',
 GET_VERIFYMAGICTOKEN_FAILED :'GET_VERIFYMAGICTOKEN_FAILED'
};

// Booking Report Download
export const GET_BOOKINGREPORTDOWNLOAD = {
  GET_BOOKINGREPORTDOWNLOAD_REQUESTED: " GET_BOOKINGREPORTDOWNLOAD_REQUESTED",
  GET_BOOKINGREPORTDOWNLOAD_SUCCESS: " GET_BOOKINGREPORTDOWNLOAD_SUCCESS",
  GET_BOOKINGREPORTDOWNLOAD_FAILED: " GET_BOOKINGREPORTDOWNLOAD_FAILED",
}

// Get Trip Price
export const GET_TRIPPRICE = {
  GET_TRIPPRICE_REQUESTED: " GET_TRIPPRICE_REQUESTED",
  GET_TRIPPRICE_SUCCESS: " GET_TRIPPRICE_SUCCESS",
  GET_TRIPPRICE_FAILED: " GET_TRIPPRICE_FAILED",
}

// Revenue Report Download
export const GET_REVENUEREPORTDOWNLOAD = {
  GET_REVENUEREPORTDOWNLOAD_REQUESTED: " GET_REVENUEREPORTDOWNLOAD_REQUESTED",
  GET_REVENUEREPORTDOWNLOAD_SUCCESS: " GET_REVENUEREPORTDOWNLOAD_SUCCESS",
  GET_REVENUEREPORTDOWNLOAD_FAILED: " GET_REVENUEREPORTDOWNLOAD_FAILED",
}

// Top Companies
export const GET_TOPCOMPANIES = {
  GET_TOPCOMPANIES_REQUESTED: " GET_TOPCOMPANIES_REQUESTED",
  GET_TOPCOMPANIES_SUCCESS: " GET_TOPCOMPANIES_SUCCESS",
  GET_TOPCOMPANIES_FAILED: " GET_TOPCOMPANIES_FAILED",
}

// Companies
export const GET_COMPANYDATA = {
  GET_COMPANYDATA_REQUESTED: " GET_COMPANYDATA_REQUESTED",
  GET_COMPANYDATA_SUCCESS: " GET_COMPANYDATA_SUCCESS",
  GET_COMPANYDATA_FAILED: " GET_COMPANYDATA_FAILED",
}

// Consolidated Invoice
export const GET_CONSOLIDATEDINVOICE = {
  GET_CONSOLIDATEDINVOICE_REQUESTED: " GET_CONSOLIDATEDINVOICE_REQUESTED",
  GET_CONSOLIDATEDINVOICE_SUCCESS: " GET_CONSOLIDATEDINVOICE_SUCCESS",
  GET_CONSOLIDATEDINVOICE_FAILED: " GET_CONSOLIDATEDINVOICE_FAILED",
}

// Company Location
export const GET_COMPANYLOCATION = {
  GET_COMPANYLOCATION_REQUESTED: " GET_COMPANYLOCATION_REQUESTED",
  GET_COMPANYLOCATION_SUCCESS: " GET_COMPANYLOCATION_SUCCESS",
  GET_COMPANYLOCATION_FAILED: " GET_COMPANYLOCATION_FAILED",
  GET_COMPANYLOCATION_CLEAR: " GET_COMPANYLOCATION_CLEAR",
}

// Company DutyType
export const GET_COMPANYDUTY = {
  GET_COMPANYDUTY_REQUESTED: " GET_COMPANYDUTY_REQUESTED",
  GET_COMPANYDUTY_SUCCESS: " GET_COMPANYDUTY_SUCCESS",
  GET_COMPANYDUTY_FAILED: " GET_COMPANYDUTY_FAILED",
  GET_COMPANYDUTY_CLEAR: " GET_COMPANYDUTY_CLEAR",
}

//Logout Action
export const GET_LOGOUT = "GET_LOGOUT";
export const GET_LOGOUT_REQUESTED = "GET_LOGOUT_REQUESTED";
export const GET_LOGOUT_SUCCESS = "GET_LOGOUT_SUCCESS";
export const GET_LOGOUT_FAILURE = "GET_LOGOUT_FAILURE";

// Car Facilities
export const GET_CARFACILTIES = {
  GET_CARFACILTIES_REQUESTED: " GET_CARFACILTIES_REQUESTED",
  GET_CARFACILTIES_SUCCESS: " GET_CARFACILTIES_SUCCESS",
  GET_CARFACILTIES_FAILED: " GET_CARFACILTIES_FAILED",
}

// Consolidate Invoice Matrix
export const GET_CONSOLIDATE_INVOICE_MATRIX = {
  GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED:"GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED",
  GET_CONSOLIDATE_INVOICE_MATRIX_SUCCESS:"GET_CONSOLIDATE_INVOICE_MATRIX_SUCCESS",
  GET_CONSOLIDATE_INVOICE_MATRIX_FAILED:"GET_CONSOLIDATE_INVOICE_MATRIX_FAILED",
}

// Final Invoice Billing
export const GET_FINAL_INVOICE = {
  GET_FINAL_INVOICE_REQUESTED:"GET_FINAL_INVOICE_REQUESTED",
  GET_FINAL_INVOICE_SUCCESS:"GET_FINAL_INVOICE_SUCCESS",
  GET_FINAL_INVOICE_FAILED:"GET_FINAL_INVOICE_FAILED",
  GET_FINAL_INVOICE_CLEARED:"GET_FINAL_INVOICE_CLEAR",
}
//Create Car Action
export const GET_ADDCAR = "GET_ADDCAR";
export const GET_ADDCAR_REQUESTED = "GET_ADDCAR_REQUESTED";
export const GET_ADDCAR_SUCCESS = "GET_ADDCAR_SUCCESS";
export const GET_ADDCAR_FAILED = "GET_ADDCAR_FAILED";

//Update Car Action
export const GET_UPDATECAR = "GET_UPDATECAR";
export const GET_UPDATECAR_REQUESTED = "GET_UPDATECAR_REQUESTED";
export const GET_UPDATECAR_SUCCESS = "GET_UPDATECAR_SUCCESS";
export const GET_UPDATECAR_FAILED = "GET_UPDATECAR_FAILED";

//Delete Car Action
export const GET_DELETECAR = "GET_DELETECAR";
export const GET_DELETECAR_REQUESTED = "GET_DELETECAR_REQUESTED";
export const GET_DELETECAR_SUCCESS = "GET_DELETECAR_SUCCESS";
export const GET_DELETECAR_FAILED = "GET_DELETECAR_FAILED";

//Facilities Action
export const GET_FACILITIES = "GET_FACILITIES";
export const GET_FACILITIES_REQUESTED = "GET_FACILITIES_REQUESTED";
export const GET_FACILITIES_SUCCESS = "GET_FACILITIES_SUCCESS";
export const GET_FACILITIES_FAILED = "GET_FACILITIES_FAILED";

//Tag Action
export const GET_TAG = "GET_TAG";
export const GET_TAG_REQUESTED = "GET_TAG_REQUESTED";
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS";
export const GET_TAG_FAILED = "GET_TAG_FAILED";

//Create Tag Action
export const GET_ADDTAG = "GET_ADDTAG";
export const GET_ADDTAG_REQUESTED = "GET_ADDTAG_REQUESTED";
export const GET_ADDTAG_SUCCESS = "GET_ADDTAG_SUCCESS";
export const GET_ADDTAG_FAILED = "GET_ADDTAG_FAILED";

//Update Tag Action
export const GET_UPDATETAG = "GET_UPDATETAG";
export const GET_UPDATETAG_REQUESTED = "GET_UPDATETAG_REQUESTED";
export const GET_UPDATETAG_SUCCESS = "GET_UPDATETAG_SUCCESS";
export const GET_UPDATETAG_FAILED = "GET_UPDATETAG_FAILED";

//Rating Action
export const GET_RATING = "GET_RATING";
export const GET_RATING_REQUESTED = "GET_RATING_REQUESTED";
export const GET_RATING_SUCCESS = "GET_RATING_SUCCESS";
export const GET_RATING_FAILED = "GET_RATING_FAILED";

//FAQ Action
export const GET_FAQ = "GET_FAQ";
export const GET_FAQ_REQUESTED = "GET_FAQ_REQUESTED";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_FAILED = "GET_FAQ_FAILED";

//Create FAQ Action
export const GET_ADDFAQ = "GET_ADDFAQ";
export const GET_ADDFAQ_REQUESTED = "GET_ADDFAQ_REQUESTED";
export const GET_ADDFAQ_SUCCESS = "GET_ADDFAQ_SUCCESS";
export const GET_ADDFAQ_FAILED = "GET_ADDFAQ_FAILED";

//Update FAQ Action
export const GET_UPDATEFAQ = "GET_UPDATEFAQ";
export const GET_UPDATEFAQ_REQUESTED = "GET_UPDATEFAQ_REQUESTED";
export const GET_UPDATEFAQ_SUCCESS = "GET_UPDATEFAQ_SUCCESS";
export const GET_UPDATEFAQ_FAILED = "GET_UPDATEFAQ_FAILED";

//Delete FAQ Action
export const GET_DELETEFAQ = "GET_DELETEFAQ";
export const GET_DELETEFAQ_REQUESTED = "GET_DELETEFAQ_REQUESTED";
export const GET_DELETEFAQ_SUCCESS = "GET_DELETEFAQ_SUCCESS";
export const GET_DELETEFAQ_FAILED = "GET_DELETEFAQ_FAILED";

//FAQ Section Action
export const GET_FAQ_SECTION = "GET_FAQ_SECTION";
export const GET_FAQ_SECTION_REQUESTED = "GET_FAQ_SECTION_REQUESTED";
export const GET_FAQ_SECTION_SUCCESS = "GET_FAQ_SECTION_SUCCESS";
export const GET_FAQ_SECTION_FAILED = "GET_FAQ_SECTION_FAILED";

// GET Admin User
export const GET_ADMINUSER = {
  GET_ADMINUSER_REQUESTED: " GET_ADMINUSER_REQUESTED",
  GET_ADMINUSER_SUCCESS: " GET_ADMINUSER_SUCCESS",
  GET_ADMINUSER_FAILED: " GET_ADMINUSER_FAILED",
}

// ADD Admin User
export const GET_ADDADMINUSER = {
  GET_ADDADMINUSER_REQUESTED: "GET_ADDADMINUSER_REQUESTED",
  GET_ADDADMINUSER_SUCCESS: "GET_ADDADMINUSER_SUCCESS",
  GET_ADDADMINUSER_FAILED: "GET_ADDADMINUSER_FAILED",
};

export const GET_UPDATEADMINUSER = {
  GET_UPDATEADMINUSER_REQUESTED: "GET_UPDATEADMINUSER_REQUESTED",
  GET_UPDATEADMINUSER_SUCCESS: "GET_UPDATEADMINUSER_SUCCESS",
  GET_UPDATEADMINUSER_FAILED: "GET_UPDATEADMINUSER_FAILED",
};

//Operation
export const GET_PARENTCOMPANYDETAILS = {
  GET_PARENTCOMPANYDETAILS_REQUESTED: "GET_PARENTCOMPANYDETAILS_REQUESTED",
  GET_PARENTCOMPANYDETAILS_SUCCESS: "GET_PARENTCOMPANYDETAILS_SUCCESS",
  GET_PARENTCOMPANYDETAILS_FAILED: "GET_PARENTCOMPANYDETAILS_FAILED"
};

//Mis Report
export const GET_MISREPORTSDOWNLOAD = {
  GET_MISREPORTSDOWNLOAD_REQUESTED: "GET_MISREPORTSDOWNLOAD_REQUESTED",
  GET_MISREPORTSDOWNLOAD_SUCCESS: "GET_MISREPORTSDOWNLOAD_SUCCESS",
  GET_MISREPORTSDOWNLOAD_FAILED: "GET_MISREPORTSDOWNLOAD_FAILED",
};

// Live Data
export const GET_RIDEDETAILSPOLYLINE = {
  GET_RIDEDETAILSPOLYLINE_REQUESTED: "GET_RIDEDETAILSPOLYLINE_REQUESTED",
  GET_RIDEDETAILSPOLYLINE_SUCCESS: "GET_RIDEDETAILSPOLYLINE_SUCCESS",
  GET_RIDEDETAILSPOLYLINE_FAILED: "GET_RIDEDETAILSPOLYLINE_FAILED",
};
// Notification Action
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATION_REQUESTED = "GET_NOTIFICATION_REQUESTED";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAILED = "GET_NOTIFICATION_FAILED";

// Notification Count Action
export const GET_NOTIFICATIONCOUNT = "GET_NOTIFICATIONCOUNT";
export const GET_NOTIFICATIONCOUNT_REQUESTED = "GET_NOTIFICATIONCOUNT_REQUESTED";
export const GET_NOTIFICATIONCOUNT_SUCCESS = "GET_NOTIFICATIONCOUNT_SUCCESS";
export const GET_NOTIFICATIONCOUNT_FAILED = "GET_NOTIFICATIONCOUNT_FAILED";

// Notification Seen Action
export const GET_NOTIFICATIONSEEN = "GET_NOTIFICATIONSEEN";
export const GET_NOTIFICATIONSEEN_REQUESTED = "GET_NOTIFICATIONSEEN_REQUESTED";
export const GET_NOTIFICATIONSEEN_SUCCESS = "GET_NOTIFICATIONSEEN_SUCCESS";
export const GET_NOTIFICATIONSEEN_FAILED = "GET_NOTIFICATIONSEEN_FAILED";

// SubCity Location
export const GET_SUBCITY = {
 GET_SUBCITY_REQUESTED: "GET_SUBCITY_REQUESTED",
 GET_SUBCITY_SUCCESS: "GET_SUBCITY_SUCCESS",
 GET_SUBCITY_FAILED: "GET_SUBCITY_FAILED",
 GET_SUBCITY_CLEAR: "GET_SUBCITY_CLEAR",
}

// Add Billing Request Link
export const ADD_BILLINGREQUESTAPPROVALLINK = {
  ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED: "ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED",
  ADD_BILLINGREQUESTAPPROVALLINK_SUCCESS: "ADD_BILLINGREQUESTAPPROVALLINK_SUCCESS",
  ADD_BILLINGREQUESTAPPROVALLINK_FAILED: "ADD_BILLINGREQUESTAPPROVALLINK_FAILED",
}

// Get complince Regex validation 
export const GET_COPMLIANCEVALIDATION = {
  GET_COPMLIANCEVALIDATION_REQUESTED: "GET_COPMLIANCEVALIDATION_REQUESTED",
  GET_COPMLIANCEVALIDATION_SUCCESS: "GET_COPMLIANCEVALIDATION_SUCCESS",
  GET_COPMLIANCEVALIDATION_FAILED: "GET_COPMLIANCEVALIDATION_FAILED",
}

//Country List
export const GET_COUNTRYCODE = {
  GET_COUNTRYCODE_REQUESTED: "GET_COUNTRYCODE_REQUESTED",
  GET_COUNTRYCODE_SUCCESS: "GET_COUNTRYCODE_SUCCESS",
  GET_COUNTRYCODE_FAILED: "GET_COUNTRYCODE_FAILED",
};

// customer Compalints Action
export const GET_CUSTOMER_COMPLAINTS = "GET_CUSTOMER_COMPLAINTS";
export const GET_CUSTOMER_COMPLAINTS_REQUESTED = "GET_CUSTOMER_COMPLAINTS_REQUESTED";
export const GET_CUSTOMER_COMPLAINTS_SUCCESS = "GET_CUSTOMER_COMPLAINTS_SUCCESS";
export const GET_CUSTOMER_COMPLAINTS_FAILED = "GET_CUSTOMER_COMPLAINTS_FAILED";

// Update Complaint Action
export const UPDATE_COMPLAINT = "UPDATE_COMPLAINT";
export const UPDATE_COMPLAINT_REQUESTED = "UPDATE_COMPLAINT_REQUESTED";
export const UPDATE_COMPLAINT_SUCCESS = "UPDATE_COMPLAINT_SUCCESS";
export const UPDATE_COMPLAINT_FAILED = "UPDATE_COMPLAINT_FAILED";

// Customer Action
export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMER_REQUESTED = "GET_CUSTOMER_REQUESTED";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAILED = "GET_CUSTOMER_FAILED";

// Update Customer Action
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_REQUESTED = "UPDATE_CUSTOMER_REQUESTED";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAILED = "UPDATE_CUSTOMER_FAILED";

//Customer Matrix Action
export const GET_MATRIXCUSTOMER = "GET_MATRIXCUSTOMER";
export const GET_MATRIXCUSTOMER_REQUESTED = "GET_MATRIXCUSTOMER_REQUESTED";
export const GET_MATRIXCUSTOMER_SUCCESS = "GET_MATRIXCUSTOMER_SUCCESS";
export const GET_MATRIXCUSTOMER_FAILED = "GET_MATRIXCUSTOMER_FAILED";

//Customer Ticket Action
export const GET_TICKETCUSTOMER = "GET_TICKETCUSTOMER";
export const GET_TICKETCUSTOMER_REQUESTED = "GET_TICKETCUSTOMER_REQUESTED";
export const GET_TICKETCUSTOMER_SUCCESS = "GET_TICKETCUSTOMER_SUCCESS";
export const GET_TICKETCUSTOMER_FAILED = "GET_TICKETCUSTOMER_FAILED";
//Driver Action
export const GET_DRIVER = "GET_DRIVER";
export const GET_DRIVER_REQUESTED = "GET_DRIVER_REQUESTED";
export const GET_DRIVER_SUCCESS = "GET_DRIVER_SUCCESS";
export const GET_DRIVER_FAILED = "GET_DRIVER_FAILED";
export const CLEAR_SELECTED_DRIVER = "CLEAR_SELECTED_DRIVER";
//Coupon Action
export const GET_COUPON = "GET_COUPON";
export const GET_COUPON_REQUESTED = "GET_COUPON_REQUESTED";
export const GET_COUPON_SUCCESS = "GET_COUPON_SUCCESS";
export const GET_COUPON_FAILED = "GET_COUPON_FAILED";

//Create Coupon Action
export const GET_ADDCOUPON = "GET_ADDCOUPON";
export const GET_ADDCOUPON_REQUESTED = "GET_ADDCOUPON_REQUESTED";
export const GET_ADDCOUPON_SUCCESS = "GET_ADDCOUPON_SUCCESS";
export const GET_ADDCOUPON_FAILED = "GET_ADDCOUPON_FAILED";

//Update Coupon Action
export const GET_UPDATECOUPON = "GET_UPDATECOUPON";
export const GET_UPDATECOUPON_REQUESTED = "GET_UPDATECOUPON_REQUESTED";
export const GET_UPDATECOUPON_SUCCESS = "GET_UPDATECOUPON_SUCCESS";
export const GET_UPDATECOUPON_FAILED = "GET_UPDATECOUPON_FAILED";

//Delete Coupon Action
export const GET_DELETECOUPON = "GET_DELETECOUPON";
export const GET_DELETECOUPON_REQUESTED = "GET_DELETECOUPON_REQUESTED";
export const GET_DELETECOUPON_SUCCESS = "GET_DELETECOUPON_SUCCESS";
export const GET_DELETECOUPON_FAILED = "GET_DELETECOUPON_FAILED";
